<template>
    <div class="company_tariffs">

        <div class="header">

            <div class="button">

                <span
                    class="btn btn-success text-center"
                    @click.prevent="new_tariff()"
                >
                    {{ translate('company_services.add_tariff') }}
                </span>

            </div>
        </div>


        <div class="row response_table">
            <table>
                <thead style="height: 50px; flex:0; display: inline-block">
                    <tr>
                        <th scope="col" style="width: 40px" >
                            {{ translate('company_services.tariff_id') }}
                        </th>
                        <th scope="col" style="width: 40px" >
                            {{ translate('company_services.tariff_active') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.tariff_name') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.tariff_client') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.tariff_descr') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.tariff_cost') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.tariff_billing') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.device_count') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.ts_end') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(tariff,key) in tariffs"
                        :key="key"
                        class="tariff_item"
                    >
                        <td :data-label="translate('company_services.tariff_id')" style="width: 40px">
                            {{ tariff.id }}
                        </td>
                        <td :data-label="translate('company_services.tariff_active')" style="width: 40px" >
                            {{ tariff.active }}
                        </td>
                        <td :data-label="translate('company_services.tariff_name')">
                            {{ tariff.tariff_name }}
                        </td>
                        <td :data-label="translate('company_services.tariff_client')">
                            {{ tariff.client_name }}
                        </td>
                        <td :data-label="translate('company_services.tariff_descr')">
                            {{ tariff.descr }}
                        </td>
                        <td :data-label="translate('company_services.tariff_cost')">
                            {{ tariff.cost }}
                        </td>
                        <td :data-label="translate('company_services.tariff_billing')">
                            {{ tariff.billing_type }}
                        </td>
                        <td :data-label="translate('company_services.device_count')">
                            {{ tariff.device_count }}
                        </td>
                        <td :data-label="translate('company_services.ts_end')" :class="{end: check_date(tariff.ts_end)}">
                            {{ get_date(tariff.ts_end) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import AddTariff from "@/views/Dashboard/common/General/CompanyServices/Modal/AddTariff.vue";

export default {
    name: 'CompanyTariffs',
    components: {
    },
    props: ['tariffs', 'clients'],

    data () {
      return {
        load: true,
      }
    },
    computed:{
        all_data(){
            return this.tariffs
        }
    },

    methods:{
        check_date(ts_end){
            let time = +new Date()
            return (time / 1000) > ts_end;
        },
        new_tariff () {
            let t = this.$createElement(AddTariff, {
                props: {
                    clients: this.clients
                },
                on: {
                    close: () => {
                        this.$modal.hide('add_tariff')
                    },
                    confirm: (val) => {
                        this.add_tariff(val)
                        this.$modal.hide('add_tariff')
                    }
                }
            })
            let temp = { render () { return t } }
            this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'add_tariff'})
        },
        add_tariff(val){
            this.$http.v1.createTariff( val,() => {
                this.global_notify('info', this.translate('company_services.tariff_added') )
                this.$emit("update")
            })
        }
    }
}
</script>

<style lang='scss' scoped>
      .company_tariffs{
            height: 100%;
            display: flex;
            flex-direction: column;
            flex: 1;
          .tariff_item{
              .end{
                  font-weight: bold;
                  color: #EB5E28;
              }
          }
      }
</style>
